import { cva } from 'class-variance-authority'

export const inputVariants = {
  base: cva([
    'py-xs',
    'pl-s',
    'pr-m',
    'rounded-lg',
    'bg-white',
    'disabled:bg-carbon-50',
    'text-primary',
    'disabled:text-carbon-400',
    'placeholder:text-carbon-400',
    'border',
    'border-carbon-400',
    'disabled:border-carbon-200',
    'enabled:hover:border-blurple-300',
    'enabled:focus-visible:border-blurple-300',
    'enabled:focus-visible:outline-2',
    'enabled:[&:user-invalid]:outline-2',
    'enabled:focus-visible:-outline-offset-1',
    'enabled:[&:user-invalid]:-outline-offset-1',
    'enabled:focus-visible:outline',
    'enabled:focus-visible:outline-blurple-300',
    'enabled:[&:user-invalid]:text-red-500',
    'enabled:[&:user-invalid]:outline',
    'enabled:[&:user-invalid]:outline-current',
    'enabled:[&:user-invalid]:border-current',
  ], {
    variants: {
      error: {
        true: ['enabled:text-red-500', 'enabled:outline', 'enabled:outline-current', 'enabled:outline', 'enabled:outline-2', 'enabled:-outline-offset-1', 'enabled:border-current'],
        false: [],
      },
      isSearch: {
        true: ['h-15', 'rounded-lg'],
        false: [],
      },
    },
  }),

  label: cva([
    'text-caption',
    'flex',
    'flex-col',
    'gap-3xs',
    'text-black',
  ]),

  search: {
    // Keep the transparent border, it prevents Safari from dropping the outer ring at some zoom levels.
    // Use `ring-*` to style the edge, not `border-*`.
    base: cva([
      'flex',
      'items-center',
      'w-full',
      'outline',
      'outline-offset-2',
      'border',
      'border-transparent',
      'ring-1',
      'ring-inset',
      'hover:ring-2',
      'bg-white',
    ], {
      variants: {
        size: {
          small: ['px-s', 'py-2.5xs'],
          medium: ['py-2.5xs', 'pl-s', 'pr-m'],
          large: ['py-xs', 'pl-s', 'pr-m'],
        },
        shape: {
          rounded: ['rounded-full'],
          square: ['rounded-lg'],
        },
        color: {
          blurple: [
            'ring-border-default',
            'hover:ring-border-primary',
            'focus:outline-blurple-200',
          ],
          carbon: [
            'ring-carbon-500',
            'hover:ring-blurple-300',
            'focus:outline-blurple-200',
            'dark:[&>button]:text-white',
            'dark:ring-neutral-white',
            'dark:focus:outline-blurple-200',
            'dark:hover:ring-blurple-200',
            'dark:bg-surface-elevated',
            'dark:[&_input]:text-white',
            'dark:[&_input]:placeholder:text-white',
          ],
          moss: [
            'ring-moss-500',
            'hover:ring-moss-300',
            'focus:outline-moss-200',
          ],
        },
      },
    }),

    input: cva([
      'w-full',
      'text-primary',
      'bg-transparent',
      'outline-none',
      'text-base',
    ]),
  },
}
